import { useLocation } from "react-router-dom";

import { ArticleType } from "./Posts/types";

export const useArticleType = (): ArticleType => {
    return useLocation().pathname.split("/").includes("blog") ? "BLOG" : "NEWS";
};
